<template>
  <div class="activity-table">
    <div
      v-if="loading"
      v-loading="loading"
      element-loading-text="Activity loading"
      element-loading-background="transparent"
      style="height: 100%"
    />
    <template v-else>
      <el-table v-if="isDesktop" :data="data" size="small">
        <el-table-column prop="title" label="Ad type" width="160">
          <template #default="{ row }">
            <AdTypeLable :id="row.type_id" :title="row.title" />
          </template>
        </el-table-column>
        <el-table-column prop="impressions" label="Impressions">
          <template #default="{ row }">
            {{ formatInteger(row.impressions) }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="useConv"
          prop="conversions"
          label="Conversions"
        />
        <el-table-column prop="spends" label="Spent">
          <template #default="{ row }">
            {{ formatMoney(row.spends, { currency: true }) }}
          </template>
        </el-table-column>
      </el-table>
      <el-table v-else :data="data" size="small">
        <el-table-column type="expand">
          <template #default="props">
            <p>
              Impressions:
              <b>{{ formatInteger(props.row.impressions) }}</b>
            </p>
            <p v-if="useConv">
              Conversion:
              <b>{{ props.row.conversions }}</b>
            </p>
            <p>
              Spent:
              <b>{{ formatMoney(props.row.spends, { currency: true }) }}</b>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="Ad type" width="160">
          <template #default="{ row }">
            <AdTypeLable :id="row.type_id" :title="row.title" />
          </template>
        </el-table-column>
        <el-table-column prop="spends" label="Spent">
          <template #default="{ row }">
            {{ formatMoney(row.spends, { currency: true }) }}
          </template>
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>

<script lang="ts">
import useResize from '@/hooks/useResize'

import { defineComponent } from 'vue'
import AdTypeLable from './AdTypeLable.vue'
import { useUserStore } from '@/store/modules/user'
import { formatMoney } from '../utils/formatters'

export default defineComponent({
  name: 'ActivityTable',
  components: {
    AdTypeLable
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array<object>,
      default: () => []
    }
  },
  setup(props) {
    const { isDesktop } = useResize()

    const userStore = useUserStore()

    const { useConv } = userStore

    const formatInteger = (value: number | string) => {
      return Math.round(Number(value || 0))
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }

    return { isDesktop, useConv, formatInteger, formatMoney }
  }
})
</script>
<style lang="scss" scoped>
.activity-table {
  padding-right: 10px;
  width: 100%;

  .el-table {
    color: var(--el-text-color-primary);
  }
}

:deep(.el-table__header-wrapper) {
  font-size: 10px;

  th .cell {
    padding-left: 5px;
    padding-right: 5px;
  }
}

:deep(.el-loading-mask) {
  margin-top: 25%;
}
</style>
